import { CoreDebugButtonType } from "../../Components/ui/react/core-controlled/debug/core-debug-dropdown-window";
import { AnimationBase, AnimationState } from "./animation-base";

export class AnimationModal extends AnimationBase<AnimationModalProps> {
    private _props: AnimationModalProps;
    private _animationProps:any = []
    public get isInited(): boolean {
        return typeof this._props !== 'undefined';
    }
    constructor(public animationType: AnimationModalType) {
        super(animationType, AnimationModalType.none);
        this._animationProps[AnimationModalType.none] = ({
            length: 0
        } as AnimationModalInternalProps)
        this._animationProps[AnimationModalType.unfold] = ({
            length: 1000
        } as AnimationModalInternalProps)

        this._animationProps[AnimationModalType.reveal] = ({
            length: 500
        } as AnimationModalInternalProps)

        // this._animationProps[AnimationModalType.uncover] = ({
        //     length: 500
        // } as AnimationModalInternalProps)

        this._animationProps[AnimationModalType.blowUp] = ({
            length: 500
        } as AnimationModalInternalProps)

        this._animationProps[AnimationModalType.runner] = ({
            length: 500
        } as AnimationModalInternalProps)
    }

    public updateProps(props: AnimationModalProps) {
        this._props = props;
    }

    public getModalBackgroundOverlayInitialClass() {
        if(!this.isAnimationEnabled()) {
            return 'core-initial-animation-class';
        }
        const animationType = this.isAnimationsEnabled ? this.animationType : AnimationModalType.none;
        const pageClass = animationType + '-root-';
        return pageClass + AnimationState.In;
    }

    public getModalContainerInitialClass() {
        if(!this.isAnimationEnabled()) {
            return 'core-initial-animation-class';
        }
        const animationType = this.isAnimationsEnabled ? this.animationType : AnimationModalType.none;
        const pageClass = animationType + '-container-';
        return pageClass + AnimationState.In;
    }

    public getModalBackgroundContainerInitialClass() {
        if(!this.isAnimationEnabled()) {
            return '';
        }
        const animationType = this.isAnimationsEnabled ? this.animationType : AnimationModalType.none;
        const pageClass = animationType + '-background-container-';
        return pageClass + AnimationState.In;
    }

    public setState (state: AnimationState, onDone?: () => void) {
        if(!this.isAnimationEnabled()) {
            if(onDone) {
                onDone();
            }
            return;
        }
        const animationType = this.isAnimationsEnabled ? this.animationType : AnimationModalType.none;
        const animationProps: AnimationModalInternalProps = this._animationProps[animationType];
        const rootClass = animationType + '-root-';
        const containerClass = animationType + '-container-';
        const bgContainerClass = animationType + '-background-container-';
        const reversedState = state === AnimationState.In ? AnimationState.Out : AnimationState.In;

        this._props.modalRoot?.classList.remove(rootClass + reversedState);
        this._props.modalContainer?.classList.remove(containerClass + reversedState);
        this._props.backgroundContentRoot?.classList.remove(bgContainerClass + reversedState);

        this._props.modalRoot?.classList.add(rootClass + state);
        this._props.modalContainer?.classList.add(containerClass + state);
        this._props.backgroundContentRoot?.classList.add(bgContainerClass + state);

        setTimeout(() => {
            this._props.modalRoot?.classList.remove(rootClass + state);
            this._props.modalContainer?.classList.remove(containerClass + state);
            this._props.backgroundContentRoot?.classList.remove(bgContainerClass + state);
            if(onDone) {
                onDone();
            }
        }, animationProps.length);
	}
}

export interface AnimationModalProps {
    /**
     * The root element of the modal (usually an object that has a semi transparent background)
     */
    modalRoot: HTMLElement;

    /**
     * The container of the modal
     */
    modalContainer: HTMLElement;

    /**
     * The root of the content that may display behind the modal
     */
    backgroundContentRoot?: HTMLElement;
}

export enum AnimationModalType {
    none = 'modal-animation-none',
    unfold = 'modal-animation-unfold',
    reveal = 'modal-animation-reveal',
    // uncover = 'modal-animation-uncover',
    blowUp = 'modal-animation-blow-up',
    runner = 'modal-animation-runner'
}

interface AnimationModalInternalProps {
    length: number;
}

export const AllModalAnimations: CoreDebugButtonType<AnimationModalType>[] = [
    {
        key: AnimationModalType.none,
        value: 'AnimationModalType.none'
    },
    {
        key: AnimationModalType.unfold,
        value: 'AnimationModalType.unfold'
    },
    {
        key: AnimationModalType.reveal,
        value: 'AnimationModalType.reveal'
    },
    // {
    //     key: AnimationModalType.uncover,
    //     value: 'AnimationModalType.uncover'
    // },
    {
        key: AnimationModalType.blowUp,
        value: 'AnimationModalType.blowUp'
    },
    {
        key: AnimationModalType.runner,
        value: 'AnimationModalType.runner'
    }
]